export function home(homeProductsData) {
  return {
    type: 'HOME',
    homeProductsData
  }
}